import gql from 'graphql-tag';

export const GET_LENDER_PERFORMANCE_FUNNEL = gql`
  query LenderPerformanceFunnel($input: LenderPerformanceReportInput!) {
    lenderPerformance {
      result: funnel(input: $input) {
        success
        error
        entity {
          submitted
          decisioned
          approved
          funded
          approvalRate
          fundRate
          responseRate
          lookToBook
        }
      }
    }
  }
`;
